import { isEmpty } from "lodash";
import React from "react";
import User from "../../assets/images/fi-rr-user.svg";
import Location from "../../assets/images/bx-location-plus.svg";
import About from "../../assets/images/about.png";
import { GenderType } from "../../interfaces/commons";
import "../../css/profileCompletionJourney.css";

type PropTypes = {
  selectedGender: GenderType | undefined;
  isChangeDifferentlyAbled: boolean;
  locationAddress: string | undefined;
  zipCode: string;
  profileTitle: string;
  profileAboutMe: string;
};

function ProfileCompletionMap(props: PropTypes) {
  const {
    selectedGender,
    isChangeDifferentlyAbled,
    locationAddress,
    zipCode,
    profileTitle,
    profileAboutMe,
  } = props;

  return (
    <div style={{ paddingLeft: "20px", width: "20%" }}>
      {!isEmpty(selectedGender) && (
        <div
          className="profile_completion_item_section"
          style={{ textAlign: "center" }}
        >
          <img src={User} style={{ height: "50px", width: "20px" }} />
          <div className="flex_column_align_center">
            <text
              className="profile_completion_item_heading"
              style={{ marginLeft: "20px" }}
            >
              I'm a{" "}
            </text>
            <text
              className="profile_completion_item_text"
              style={{ marginLeft: "20px" }}
            >
              {selectedGender?.text}
            </text>
          </div>
        </div>
      )}

      {!isEmpty(locationAddress) && (
        <div className="profile_completion_item_section">
          <img
            src={Location}
            alt=""
            style={{ height: "50px", width: "20px", marginRight: "20px" }}
          />
          <div>
            <>
              <div className="flex_column_align_center">
                <text className="profile_completion_item_heading">
                  I'm from{" "}
                </text>

                <text className="profile_completion_item_text">
                  {locationAddress}
                </text>
              </div>
            </>
          </div>
        </div>
      )}

      {!isEmpty(zipCode) && (
        <div className="profile_completion_item_section">
          <img
            src={Location}
            alt=""
            style={{ height: "50px", width: "20px", marginRight: "20px" }}
          />
          <div>
            <>
              <div className="flex_column_align_center">
                <text className="profile_completion_item_heading">
                  My zipcode is{" "}
                </text>

                <text className="profile_completion_item_text">{zipCode}</text>
              </div>
            </>
          </div>
        </div>
      )}

      {!isEmpty(profileTitle) && (
        <div className="profile_completion_item_section">
          <img
            src={About}
            alt=""
            style={{
              height: "40px",
              width: "30px",
              marginRight: "18px",
              resize: "block",
            }}
          />
          <div className="flex_column_align_center">
            <text className="profile_completion_item_heading">
              By profession, I'm a{" "}
            </text>
            <text className="profile_completion_item_text">{profileTitle}</text>
          </div>
        </div>
      )}

      {!isEmpty(profileAboutMe) && (
        <div className="profile_completion_item_section">
          <img
            src={About}
            alt=""
            style={{
              height: "40px",
              width: "30px",
              marginRight: "18px",
              resize: "block",
            }}
          />
          <div className="flex_column_align_center">
            <text className="profile_completion_item_heading">About me </text>
            <text className="profile_completion_item_text">
              {profileAboutMe}
            </text>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProfileCompletionMap;
